import { averageLevel } from '@core/utils/balancer';

// O nível do time como texto, pronto para a tela.
//
// Existe para que as quatro telas que mostram isso não repitam a formatação e
// acabem divergindo: uma com vírgula, outra com ponto, uma com duas casas.
// O cálculo em si vive no core, junto do balanceador que produz a soma.

export function formatTeamLevel(
  totalStars: number,
  playerCount: number,
  language: string,
): string {
  // Uma casa SEMPRE, inclusive em 3,0: sem `minimumFractionDigits` um time daria
  // "3" e o outro "3,2", e a diferença pareceria maior do que é.
  return averageLevel(totalStars, playerCount).toLocaleString(language, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
}

/**
 * A diferença de nível entre dois jogadores, COM sinal.
 *
 * O sinal é a informação: "+0,5" e "−0,5" são situações opostas na hora de
 * escolher com quem trocar, e um número sem sinal obrigaria a pessoa a comparar
 * de cabeça com o nível do jogador que ela mesma acabou de marcar. Zero sai sem
 * sinal, porque "±0,0" não quer dizer nada.
 */
export function formatLevelDelta(delta: number, language: string): string {
  return delta.toLocaleString(language, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    signDisplay: 'exceptZero',
  });
}

/**
 * Uma diferença de nível médio, na mesma escala e com a mesma casa decimal.
 *
 * Separada de `formatTeamLevel` porque a entrada já vem calculada (o core
 * devolve a diferença pronta), mas a saída tem de ser idêntica: "0,7" e não
 * "0.7" em português, e "0,0" e não "0" quando os dois times empatam.
 */
export function formatLevelGap(gap: number, language: string): string {
  return gap.toLocaleString(language, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
}
